import React from "react";
import { GridCellKind, measureTextCached } from "@glideapps/glide-data-grid";
import "../../../icons/Icon.js";
import { customIconCharacterMapping } from "../../../icons/types.js";
import "../../../icons/ExpandMoreIcon.js";
import { CanvasRenderingContext2DExtended } from "../CanvasRenderingContext2DExtended.js";
import { rowHeight } from "../types.js";
import { GlideCell } from "./GlideCell.js";
class GlideChipCell extends GlideCell {
  _cellKind = "chip";
  constructor(valueGetter, emptySymbol) {
    super(valueGetter, emptySymbol);
  }
  getRenderer(muiTheme) {
    const padding = muiTheme.spacing(1);
    const chipPadding = typeof padding === "string" ? Number.parseInt(padding) : padding;
    const fontSizeProperty = muiTheme.typography.body1.fontSize;
    const fontSize = typeof fontSizeProperty === "string" ? Number.parseInt(fontSizeProperty) : fontSizeProperty;
    return {
      kind: GridCellKind.Custom,
      isMatch: (cell) => cell.data.kind === this._cellKind,
      needsHover: true,
      needsHoverPosition: true,
      draw: (args, cell) => {
        const { ctx, theme, rect } = args;
        const { value, type, color, startIcon } = cell.data.value;
        const baseColor = muiTheme.custom.palette.status[color];
        const drawArea = this.getDrawArea(rect, theme);
        const textFont = `${fontSize}px ${theme.fontFamily}`;
        ctx.font = textFont;
        const textMetrics = measureTextCached(value, ctx);
        const chipRect = this.getChipRectangle(textMetrics, drawArea, chipPadding, fontSize, !!startIcon);
        ctx.beginPath();
        ctx.fillStyle = baseColor.light;
        ctx.roundRect(
          chipRect.x,
          chipRect.y,
          chipRect.width,
          chipRect.height,
          Number.parseInt(muiTheme.spacing(type === "round" ? 2 : 0.5))
        );
        ctx.fill();
        ctx.fillStyle = baseColor?.main;
        if (startIcon) {
          ctx.font = `${fontSize}px icomoon`;
          ctx.fillText(customIconCharacterMapping[startIcon], drawArea.x + chipPadding, drawArea.y + rowHeight / 2);
        }
        ctx.font = textFont;
        const textRect = this.getTextRectangle(chipRect.width, chipPadding, drawArea, fontSize, !!startIcon);
        const textCtx = new CanvasRenderingContext2DExtended(args.ctx);
        textCtx.fillTextWithEllipsis(value, textRect.width, textRect.x, textRect.y);
      }
    };
  }
  getCustomContent(value) {
    return {
      kind: GridCellKind.Custom,
      copyData: value.value,
      data: {
        kind: this._cellKind,
        value,
        tooltip: ChipCellTooltipContent
      },
      allowOverlay: false
    };
  }
  formatValue(value) {
    if (value?.value && typeof value?.value !== "string") {
      throw new Error(`Invalid value: ${value.value}`);
    }
    return value ? {
      ...value,
      type: value.type ?? "round",
      color: value.color ?? "lightGrey"
    } : null;
  }
  isCellEmpty(value, isSummary) {
    return isSummary || !value?.value || !value?.type;
  }
  getChipRectangle(metrics, rect, chipPadding, fontSize, withIcon) {
    const verticalPadding = chipPadding / 2;
    const baselineHeight = metrics.actualBoundingBoxAscent / 2;
    const chipWidth = metrics.width + chipPadding * 2 + (withIcon ? fontSize + chipPadding : 0);
    const chipHeight = fontSize + baselineHeight + verticalPadding * 2;
    return {
      x: rect.x,
      y: rect.y + rowHeight / 2 - chipHeight / 2,
      width: chipWidth > rect.width ? rect.width : chipWidth,
      height: chipHeight
    };
  }
  getTextRectangle(chipWidth, chipPadding, rect, fontSize, withIcon) {
    const iconWithSpaceWidth = chipPadding + fontSize;
    return {
      x: rect.x + chipPadding + (withIcon ? iconWithSpaceWidth : 0),
      y: rect.y + rowHeight / 2,
      width: chipWidth - chipPadding * 2 - (withIcon ? iconWithSpaceWidth : 0),
      height: fontSize
    };
  }
}
function ChipCellTooltipContent({ value }) {
  return /* @__PURE__ */ React.createElement("div", null, value?.value);
}
export {
  GlideChipCell
};
//# sourceMappingURL=GlideChipCell.js.map
